export default "__VITE_ASSET__D8H8cVk3__"